import { Route, Routes, useNavigate} from 'react-router-dom';
import { StandardViewPanel } from '../../../_components/panel/standardView.panel';
import { getDateString } from '../../../_helpers/dateTime.helper';
import { ClientCareInfoManageDrawer } from './client-careInfoManageDrawer';

export const ClientCareInfoPanel = ({ data, isLoading, onRefresh }: any) => {
    const navigate = useNavigate();

    const rows = [
        { label: 'LHO Area', value: data.lhoAreaName },
        { label: 'Care Status', value: data.careStatusName },
        { label: 'Date of Admission', value: data.dateOfAdmission ? getDateString(data.dateOfAdmission) : "" },
        { label: 'Keyworker 1', value: data.primaryKeyWorkerName },
        { label: 'Keyworker 2', value: data.secondaryKeyWorkeryName },
        { label: 'Case Manager', value: data.caseManagerName },
    ]

    return (
        <>
            <StandardViewPanel
                title="Care Info" buttons={[
                    { icon: "edit", onClick: () => { navigate("ManageCareInfo/") } }
                ]}
                loading={isLoading}
                items={rows} />
            <Routes>
                <Route path="ManageCareInfo/" element={<ClientCareInfoManageDrawer onSave={() => { navigate(""); onRefresh(); }} onClose={() => { navigate(""); onRefresh(); }} />} />
            </Routes>
        </>
    );
};